(ns frontend.ux-overhaul.listing.generic.facets-event
  (:require
   [common.opensearch.facet-policy :as facet-policy]
   [common.opensearch.filter-queries :as os-filter-queries]
   [fx.ajax :as ajax]
   [re-frame.core :as rf]
   [ui.editors.simple-filters.event :as simple-filters-event]))

(defn- bucket->facet-option
  [{:keys [value label count from to]}]
  (let [resolved-value value
        resolved-label (or label
                           (when (keyword? resolved-value)
                             (name resolved-value))
                           (some-> resolved-value str))]
    (when (some? resolved-value)
      {:value resolved-value
       :label resolved-label
       :count count
       :from from
       :to to})))

(defn- resolved-facet-mode
  [{:keys [field-data-type field-filter-type]}]
  (facet-policy/facet-mode {:data-type field-data-type
                            :filter-type field-filter-type}))

(rf/reg-event-fx
  ::load-facets-ok
  (fn [_ [_ {:keys [editor-id field-path start-index page-size]} resp]]
    (let [body (or (:body resp) resp)
          facet-options (->> (or (:buckets body) [])
                             (map bucket->facet-option)
                             (remove nil?)
                             vec)
          page-options (->> facet-options
                            (drop start-index)
                            (take page-size)
                            vec)
          next-offset (+ start-index (count page-options))
          has-more (< next-offset (count facet-options))]
      {:fx [[:dispatch [::simple-filters-event/set-field-facets
                        editor-id
                        field-path
                        {:options page-options
                         :append? (pos? start-index)
                         :has-more has-more
                         :next-offset next-offset}]]]})))

(rf/reg-event-fx
  ::load-facets-failed
  (fn [_ [_ {:keys [editor-id field-path]} error]]
    {:fx [[:dispatch [::simple-filters-event/set-field-facets-error
                      editor-id
                      field-path
                      error]]]}))

(rf/reg-event-fx
  ::load-facets
  (fn [_ [_ {:keys [editor-id field-path field-data-type field-filter-type
                    filters-by-field-path search-text offset limit context
                    field-data-types-by-path]}]]
    (let [start-index (or offset 0)
          page-size (or limit 50)
          fetch-limit (+ start-index page-size)
          entity-type (:entity-type context)
          pipeline-id (:pipeline-id context)
          normalized-field-path (os-filter-queries/normalize-field-path field-path)
          data-types-by-path (merge (os-filter-queries/field-data-type-by-path context)
                                    (or field-data-types-by-path {}))
          resolved-field-data-type (get data-types-by-path normalized-field-path)
          opensearch-queries (os-filter-queries/opensearch-queries-for-facets
                              {:field-path field-path
                               :filters-by-field-path filters-by-field-path
                               :search-text search-text
                               :context context
                               :field-data-types-by-path field-data-types-by-path})
          facet-mode (resolved-facet-mode {:field-data-type (or resolved-field-data-type field-data-type)
                                           :field-filter-type field-filter-type})
          request-body (cond-> {:entity-type entity-type
                                :field-path field-path
                                :limit fetch-limit}
                         (seq opensearch-queries)
                         (assoc :opensearch-queries opensearch-queries)
                         (some? pipeline-id)
                         (assoc :pipeline-id pipeline-id)
                         (some? facet-mode)
                         (assoc :facet-mode facet-mode))]
      {::ajax/send {:operation :search/facets
                    :body request-body
                    :timeout-ms 60000
                    :on-ok [::load-facets-ok
                            {:editor-id editor-id
                             :field-path field-path
                             :start-index start-index
                             :page-size page-size}]
                    :on-error [::load-facets-failed
                               {:editor-id editor-id
                                :field-path field-path}]}})))
